// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__IGJWr","dragIcon":"SortableItem_dragIcon__2IPgm","disabled":"SortableItem_disabled__vb2Nl"};